import React from "react";

/**
 * App-level error boundary: a render error anywhere below shows a friendly
 * recovery card instead of a white screen. "Try again" re-renders in place
 * (enough for transient data-shape errors); "Reload page" is the hard reset.
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("Unhandled render error:", error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-8 text-center space-y-4">
          <div className="text-4xl">😵</div>
          <h1 className="text-lg font-semibold text-gray-900">Something went wrong</h1>
          <p className="text-sm text-gray-500">
            The page hit an unexpected error. Your data is safe — try again, or reload the page.
          </p>
          <div className="flex justify-center gap-2 pt-2">
            <button
              type="button"
              onClick={() => this.setState({ hasError: false })}
              className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Try again
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-md bg-[#372e5e] hover:bg-[#2a2349] text-sm font-medium text-white"
            >
              Reload page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
